import { FeatureFlagsCharmStub, SkypeCharmStub } from './charmStubs';
import DiagnosticsCharm from './DiagnosticsCharm';
import FeedbackCharm from './FeedbackCharm';
import GetStartedCharm from './GetStartedCharm';
import HeaderBase from './HeaderBase';
import HeaderPersona from './HeaderPersona';
import HelpCharm from './HelpCharm';
import MergedNotificationPane from './MergedNotificationPane';
import PremiumOlkCharm from './PremiumOlkCharm';
import SettingsCharm from './SettingsCharm';
import TimePanelCharm from './TimePanelCharm';
import TodoCharm from './TodoCharm';
import WaffleCharm from './WaffleCharm';
import WhatsNewCharm from './WhatsNewCharm';
import { observer } from 'mobx-react';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getScenarioStore, SearchScenarioId } from 'owa-search';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isTimePanelAvailable } from 'owa-time-panel/lib/utils/isTimePanelAvailable';
import { isTodoPanelAvailable } from 'owa-todos/lib/utils/isTodoPanelAvailable';
import * as React from 'react';
import { isGetStartedInFlexPaneEnabled } from 'owa-get-started/lib/utils/isGetStartedInFlexPaneEnabled';

export interface HeaderViewProps {
    headerLeftSectionStyle?: React.CSSProperties;
    centeredSearchBox?: boolean; // Defaults to true; this allows modules to opt out.
}

function getDiagnosticCharm(): JSX.Element {
    return (
        isFeatureEnabled('fwk-devTools') && (
            <DiagnosticsCharm key="diagnostics" DiagnosticsPanel={null} />
        )
    );
}

export function getMergedNotificationPane(): JSX.Element {
    return (
        <MergedNotificationPane
            key="notificationPane"
            offset={{
                top: '48px',
                right: '0px',
            }}
        />
    );
}

function getFeatureDiscoveryCharm(): JSX.Element[] {
    return [
        isGetStartedInFlexPaneEnabled() && <GetStartedCharm key="getstarted" />,
        isFeatureEnabled('whatsNew-Pane') && <WhatsNewCharm key="whatsnew" />,
    ];
}

@observer
export default class Header extends React.Component<HeaderViewProps, {}> {
    render() {
        const searchStore = getScenarioStore(SearchScenarioId.Mail);

        const { headerLeftSectionStyle, children, centeredSearchBox = true } = this.props;

        return (
            <HeaderBase
                searchMode={!!searchStore.searchSessionGuid}
                headerLeftSectionStyle={headerLeftSectionStyle}
                leftCharms={[<WaffleCharm key="waffle" />]}
                rightCharms={this.getConsumerRightHeaderCharms()}
                centeredSearchBox={centeredSearchBox}>
                {children}
            </HeaderBase>
        );
    }

    private getConsumerRightHeaderCharms(): JSX.Element[] {
        return [
            !isFeatureEnabled('fwk-partner-code-off') &&
                (isFeatureEnabled('fwk-skypeConsumer') || isFeatureEnabled('fwk-skypeBusiness')) &&
                !getUserConfiguration().SessionSettings.IsShadowMailbox && (
                    <SkypeCharmStub key="skype" />
                ),
            getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox &&
                isFeatureEnabled('auth-leftNavPremiumUpsell') &&
                !getUserConfiguration().SessionSettings.IsShadowMailbox && (
                    <PremiumOlkCharm key="premium" />
                ),
            isTodoPanelAvailable() && <TodoCharm key="todo" />,
            isTimePanelAvailable() && <TimePanelCharm key="timePanel" />,
            <SettingsCharm key="settings" />,
            ...getFeatureDiscoveryCharm(),
            <HelpCharm key="help" />,
            isFeatureEnabled('fwk-feedbackCharm') && <FeedbackCharm key="feedback" />,
            isFeatureEnabled('fwk-devTools') && <FeatureFlagsCharmStub key="features" />,
            getDiagnosticCharm(),
            <HeaderPersona key="mePersona" />,
            getMergedNotificationPane(),
        ];
    }
}
